module.exports = __webpack_public_path__ + "img/service-resource10.ca26d119.jpg";